import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  JOB_SITE_TRANSMITTALS_REFRESH: createSagaAction('JOB_SITE_TRANSMITTALS_REFRESH'),

  JOB_SITE_TRANSMITTAL_CREATE: createSagaAction('JOB_SITE_TRANSMITTAL_CREATE'),
  JOB_SITE_TRANSMITTAL_UPDATE: createSagaAction('JOB_SITE_TRANSMITTAL_UPDATE'),
  JOB_SITE_TRANSMITTAL_DELETE: createSagaAction('JOB_SITE_TRANSMITTAL_DELETE'),

  UPLOAD_TRANSMITTAL_ATTACHMENT: createSagaAction('UPLOAD_TRANSMITTAL_ATTACHMENT'),
  GET_TRANSMITTAL_ATTACHMENTS: createSagaAction('GET_TRANSMITTAL_ATTACHMENTS'),
  UPDATE_TRANSMITTAL_ATTACHMENT_DESCRIPTION: createSagaAction(
    'UPDATE_TRANSMITTAL_ATTACHMENT_DESCRIPTION'
  ),
  DELETE_TRANSMITTAL_ATTACHMENT: createSagaAction('DELETE_TRANSMITTAL_ATTACHMENT'),

  GET_TRANSMITTAL_DATA: createSagaAction('GET_TRANSMITTAL_DATA')
}

// Action Creators
export const actions = {
  jobSiteTransmittalsRefresh: ({ jobId, next }) => ({
    type: constants.JOB_SITE_TRANSMITTALS_REFRESH.ACTION,
    jobId,
    next
  }),

  createTransmittal: ({ jobId, content, sending, transmittalItems, transmitted, userId }) => ({
    type: constants.JOB_SITE_TRANSMITTAL_CREATE.ACTION,
    jobId,
    content,
    sending,
    transmittalItems,
    transmitted,
    userId
  }),

  updateTransmittal: ({
    jobId,
    transmittalId,
    content,
    sending,
    transmittalItems,
    transmitted,
    userId
  }) => ({
    type: constants.JOB_SITE_TRANSMITTAL_UPDATE.ACTION,
    jobId,
    transmittalId,
    content,
    sending,
    transmittalItems,
    transmitted,
    userId
  }),

  deleteTransmittal: ({ transmittalId, jobId }) => ({
    type: constants.JOB_SITE_TRANSMITTAL_DELETE.ACTION,
    jobId,
    transmittalId
  }),

  getTransmittalData: transmittalId => ({
    type: constants.GET_TRANSMITTAL_DATA.ACTION,
    transmittalId
  }),

  uploadAttachment: ({ formData, transmittalId }) => ({
    type: constants.UPLOAD_TRANSMITTAL_ATTACHMENT.ACTION,
    formData,
    transmittalId
  }),

  getTransmittalAttachments: ({ transmittalId }) => ({
    type: constants.GET_TRANSMITTAL_ATTACHMENTS.ACTION,
    transmittalId
  }),

  updateAttachmentDescription: ({ attachmentId, transmittalId, description, userId }) => ({
    type: constants.UPDATE_TRANSMITTAL_ATTACHMENT_DESCRIPTION.ACTION,
    attachmentId,
    transmittalId,
    description,
    userId
  }),

  deleteAttachment: ({ attachmentId, transmittalId }) => ({
    type: constants.DELETE_TRANSMITTAL_ATTACHMENT.ACTION,
    attachmentId,
    transmittalId
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AUTHENTICATION_LOGOUT:
      return initialState
    case constants.JOB_SITE_TRANSMITTALS_REFRESH.ACTION:
      return { ...state, error: null, loading: true }
    case constants.JOB_SITE_TRANSMITTALS_REFRESH.SUCCESS:
      return {
        ...state,
        jobSiteTransmittals: action.payload
      }
    case constants.JOB_SITE_TRANSMITTALS_REFRESH.FAILED:
      return {
        error: action.message
      }
    case constants.JOB_SITE_TRANSMITTAL_CREATE.SUCCESS:
      return {
        ...state
      }
    case constants.JOB_SITE_TRANSMITTAL_UPDATE.SUCCESS:
      return {
        ...state
      }
    case constants.JOB_SITE_TRANSMITTAL_DELETE.SUCCESS:
      return {
        ...state
      }
    case constants.GET_TRANSMITTAL_DATA.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_TRANSMITTAL_DATA.SUCCESS:
      return {
        ...state,
        transmittalData: action.payload
      }
    case constants.GET_TRANSMITTAL_DATA.FAILED:
      return {
        error: action.message
      }

    case constants.UPLOAD_TRANSMITTAL_ATTACHMENT.ACTION:
      return { ...state, error: null, uploadingAttachment: true }
    case constants.UPLOAD_TRANSMITTAL_ATTACHMENT.SUCCESS:
      return {
        ...state,
        uploadingAttachment: false
      }

    case constants.GET_TRANSMITTAL_ATTACHMENTS.ACTION:
      return { ...state, error: null, loadingAttachments: true }
    case constants.GET_TRANSMITTAL_ATTACHMENTS.SUCCESS:
      return {
        ...state,
        jobTransmittalAttachments: action.payload,
        loadingAttachments: false
      }

    case constants.UPDATE_TRANSMITTAL_ATTACHMENT_DESCRIPTION.SUCCESS:
      return {
        ...state
      }

    case constants.DELETE_TRANSMITTAL_ATTACHMENT.ACTION:
      return { ...state, error: null, deletingAttachment: true }
    case constants.DELETE_TRANSMITTAL_ATTACHMENT.SUCCESS:
      return {
        ...state,
        deletingAttachment: false
      }

    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/jobFunctions/jobSiteTransmittalActions.js